// validation.js
import { fetchZipCode } from '../../../../app/api/zipCodeApi';
import { ZIPCODE_LENGTH } from '../../../../constants/progressBanner';

export const validateZipCode = async zipCode => {
    if (zipCode.length < ZIPCODE_LENGTH.MIN) {
        return {
            isValid: false,
            error: '',
            data: null,
        };
    }

    if (zipCode.length > ZIPCODE_LENGTH.MAX) {
        return {
            isValid: false,
            error: '無効な郵便番号です。',
            data: null,
        };
    }

    const response = await fetchZipCode(zipCode);

    if (response.status !== 'success' || !response.data || response.data.length === 0) {
        return {
            isValid: false,
            error: '該当する住所が見つかりませんでした。',
            data: null,
        };
    }

    const addressData = response.data[0];
    const prefName = addressData.prefecture_name;
    const cityName = addressData.city_name;
    const prefId = addressData.prefecture_id;
    const address = `${addressData.prefecture_name}${addressData.city_name}`;

    return {
        isValid: true,
        error: '',
        data: {
            prefectureId: prefId,
            cityName,
            address,
            cityId: addressData.city_id,
            cityAddressId: addressData.id,
        },
    };
};
